import { AD_SERVERS } from '../../../configs/constants';
import { IBidder, MappingType, SizeType } from '../../../uanc.types';
import { IAdsToEmbed, IArtSponsParams, ServiceSlotType, TargetingParamsType, TargetingType } from '../ad-services.types';
import { IPbjsBidResponse } from '../../prebid/prebid.types';
import SlotRenderEndedEvent = googletag.events.SlotRenderEndedEvent;

export type PubAdsService = ReturnType<typeof googletag.pubads>;
export const isPubAdsService = (obj: any): obj is PubAdsService => {
    return obj && typeof obj.addEventListener === 'function' && typeof obj.refresh === 'function';
};

// [nazwa_slota]: [placementid]
// { rectangle: ['rectangle_01', 'rectangle_02', 'rectangle_03] }
export interface IDefinedAdUnits {
    [key: string]: string[];
}

export interface IRenderedPlacementDFP extends Pick<SlotRenderEndedEvent, 'isEmpty' | 'advertiserId' | 'campaignId' | 'creativeId'> {
    isDisplayed: boolean;
    path: string;
    bids?: IPbjsBidResponse[] | null;
    currentSize: number[] | string | null;
}

export interface IRenderedPlacementsDFP {
    [key: string]: IRenderedPlacementDFP;
}

export interface IDFPServiceSlot {
    name: string;
    adServer: AD_SERVERS;
    disable: boolean;
    bidders: IBidder[];
    renderedPlacements: IRenderedPlacementsDFP | null;
    isLazyLoading: boolean;
    isTest: boolean;
    keywords: [];
    lazyLoadingPosition: number;
    loadingTime: number;
    mapping: MappingType[];
    outOfPage: boolean;
    path: string | null;
    placementIds: string[];
    prebid?: boolean;
    refreshed: number;
    sizes: SizeType[];
    slotid: string;

    isLazyLoadingConsole?: boolean;
    shouldBeDisplayed?: boolean;
    isNative?: boolean;
    smartIsLazyLoading?: boolean;
    smartLL?: boolean;
    smartLLName?: string;
    dfp?: boolean;
}

export interface IDFPService {
    isEnabled: boolean;
    mapping: {
        [key: string]: googletag.SizeMappingArray;
    };
    adUnits: { [key: string]: googletag.Slot };
    type: string;
    keywords: string[];
    slots: IDFPServiceSlot[];
    inView: { [key: string]: boolean };
    linkSponsPendingItems: {
        data: {
            [key: string]: IArtSponsParams | null;
        };
        dataRequests: {
            [key: string]: ((data: IArtSponsParams | null) => void) | null;
        };
    };
    groupExecutionItem?: IAdsToEmbed;
}

export interface IServiceDFPUtils {
    insertAds: (adsToEmbed: IAdsToEmbed) => Promise<void>;
    lazyLoadInsertAd: (slotConfig: ServiceSlotType, placementIdsToInsert: string[], targeting: TargetingType | null) => void;
    refreshAd: (slotConfig: ServiceSlotType, placementNamesToRefresh: string[], targeting: TargetingType | null) => Promise<void>;
    refreshAds: (adUnitNamesToRefresh: string[], targeting: TargetingType | null) => Promise<void>;
    destroyAd: (slotConfig: ServiceSlotType, placementIdToDestroy: string | null) => void;
    setArtSponsParams: (name: string, data: IArtSponsParams | null) => void;
    getArtSponsParams: (name: string, cb: ((data: IArtSponsParams | null) => void) | null) => IArtSponsParams | null;
    setTargeting: (key: string, params: TargetingParamsType) => void;
    getTargeting: (key: string) => string[] | null;
}
